module.exports = __webpack_public_path__ + "static/img/about10.47d3ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about10.png
// module id = WGaS
// module chunks = 1